import type * as React from 'react';
import { OrgSwitcher } from '@redhand/ui';
import { PageIntro, StateSection } from '../ui-helpers.js';

export function OrgSwitcherPage(): React.JSX.Element {
  return (
    <div>
      <PageIntro
        title="OrgSwitcher"
        lead="Aktivní organizace/shop je vidět vždy — ochrana proti akci v cizím kontextu. REOS: kancelář + pobočky, Kokpit: shopy, Fakturace: účetní jednotky."
      />
      <StateSection title="Organizace s pobočkami (REOS)">
        <OrgSwitcher
          label="Aktivní organizace"
          orgName="Realitní kancelář Vltava s.r.o."
          unitSelectLabel="Vybrat pobočku"
          units={[
            { id: 'o1', name: 'Praha — Smíchov' },
            { id: 'o2', name: 'České Budějovice' },
            { id: 'o3', name: 'Tábor' },
          ]}
          activeUnitId="o2"
          onUnitChange={() => {}}
        />
      </StateSection>
      <StateSection title="Multi-shop (Kokpit)">
        <OrgSwitcher
          label="Aktivní shop"
          orgName="Markéta — správa shopů"
          unitSelectLabel="Vybrat shop"
          units={[
            { id: 's1', name: 'pivoachleba.cz' },
            { id: 's2', name: 'SportActions' },
          ]}
          activeUnitId="s1"
          onUnitChange={() => {}}
        />
      </StateSection>
      <StateSection title="Bez jednotek (jediná organizace)">
        <OrgSwitcher label="Aktivní organizace" orgName="Fakturace — Kominictví Vondráček" unitSelectLabel="Vybrat jednotku" />
      </StateSection>
      <StateSection title="Dlouhá čeština" description="Název se zkracuje trojtečkou, layout drží.">
        <OrgSwitcher
          label="Aktivní organizace"
          orgName="SPOLEČENSTVÍ VLASTNÍKŮ JEDNOTEK domu čp. 1502 na Sídlišti Pod Hůrkou, Klatovy III"
          unitSelectLabel="Vybrat pobočku"
          units={[{ id: 'u1', name: 'Správa nemovitostí a účetnictví, pobočka Klatovy — Pod Hůrkou' }]}
          activeUnitId="u1"
          onUnitChange={() => {}}
        />
      </StateSection>
    </div>
  );
}
